/** True when the current URL is a Keycloak OAuth redirect (authorization code or implicit tokens). */
export function isKeycloakOAuthCallback(): boolean {
  if (typeof window === 'undefined') return false;
  const search = window.location.search;
  const hash = window.location.hash;
  return (
    search.includes('code=') ||
    search.includes('state=') ||
    search.includes('session_state=') ||
    search.includes('error=') ||
    hash.includes('code=') ||
    hash.includes('state=') ||
    hash.includes('access_token=') ||
    hash.includes('id_token=')
  );
}
